import {useMemo, useRef} from 'react';
import {QueryStatus} from '@reduxjs/toolkit/query/react';
import isEqual from 'lodash/isEqual';
import type {DataLoadStatus} from 'api/types';
import type {Lock} from 'services/locks/types';
import {Configuration} from 'configuration';
import {useGetLockQuery} from 'services/locks';

const LOCK_REFRESH_INTERVAL_MS = 5 * 1000;

export const useCurrentLock = (
  workId: string,
  _mock?: boolean,
): DataLoadStatus<Lock | undefined> => {
  const resultRef = useRef<DataLoadStatus<Lock | undefined>>({
    status: 'NotLoaded',
  });

  const {data, status} = useGetLockQuery(
    {contextId: workId, contextType: 'work'},
    {
      pollingInterval: Configuration.interval.lock ?? LOCK_REFRESH_INTERVAL_MS,
    },
  );

  return useMemo(() => {
    if (status === QueryStatus.fulfilled) {
      const newLock: DataLoadStatus<Lock | undefined> = {
        status: 'Loaded',
        data,
      };

      if (!isEqual(resultRef.current, newLock)) {
        resultRef.current = newLock;
      }
    }

    return resultRef.current;
  }, [status, data]);
};
